import {
  getStateByKey,
  getCountryByKey,
  getCountryByShortKey,
  mapReplacedSubdivision,
} from '@wix/locale-dataset-javascript';
import {AddressModel} from '../models/checkout/Cart/Address.model';
import type {Country} from '@wix/locale-dataset-data';

export const isSubdivisionValidForCountry = (address?: AddressModel): boolean => {
  const country: Country = getCountryFromLocaleDataset(address?.country ?? '');

  if (!country?.subdivisions) {
    return true;
  }

  return isSubdivisionInCountry(country, address?.subdivision);
};

function isSubdivisionInCountry(country: Country, subdivisionKey: string = '') {
  const fullSubdivisionKey = mapReplacedSubdivision(subdivisionKey, country.key);
  const shortSubdivisionKey = fullSubdivisionKey.substring(fullSubdivisionKey.indexOf('-') + 1);
  return !!country?.subdivisions?.list?.some((subdivision) => subdivision.key === shortSubdivisionKey);
}

export function getSubdivisionName(countryKey?: string, subdivisionKey?: string): string | undefined {
  if (!countryKey || !subdivisionKey) {
    return;
  }

  const key = mapReplacedSubdivision(subdivisionKey, countryKey);
  const shortSubdivisionKey = key.substring(key.indexOf('-') + 1);
  return getStateByKey(countryKey, shortSubdivisionKey)?.displayName;
}

export function getCountryName(countryKey?: string): string | undefined {
  return countryKey ? getCountryByShortKey(countryKey)?.displayName : /* istanbul ignore next */ undefined;
}

export const getCountryFromLocaleDataset = (country: string): Country => {
  return getCountryByShortKey(country, {
    deprecationTimestamps: [],
  });
};

export const getCountryShortKey = (country: string) => {
  return getCountryByKey(country)?.shortKey;
};

export const getFullSubdivisionCode = (country: string, subdivision: string) => {
  const shortKeyCountry = getCountryShortKey(country);
  return shortKeyCountry && !subdivision.includes('-') ? `${shortKeyCountry}-${subdivision}` : subdivision;
};
